var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "kanban-contact-list-container" }, [
    _c("div", { staticClass: "kanban-toolbar" }, [
      _c(
        "div",
        { staticClass: "toolbar-left" },
        [
          _c("div", { staticClass: "filter-info" }, [
            _c("i", { staticClass: "material-icons filter-icon" }, [
              _vm._v(_vm._s(_vm.filterIcon)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "filter-name" }, [
              _vm._v(_vm._s(_vm.filterName)),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "state-selector-wrapper" },
            [
              _c(
                "a-tooltip",
                {
                  attrs: {
                    placement: "top",
                    title:
                      _vm.$t("chat.tableContactList.chatStatus") +
                      ": " +
                      _vm.getStatusTitle(_vm.effectiveState),
                    "mouse-enter-delay": 0.4,
                  },
                },
                [
                  _c("MinimalPopoverSelect", {
                    staticClass: "state-selector",
                    attrs: {
                      value: _vm.effectiveState,
                      options: _vm.stateOptions,
                      icon: "layers",
                      "show-dropdown-arrow": false,
                      "button-class": "chip",
                    },
                    on: { change: _vm.onStateChange },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "SupsisButton",
            {
              staticClass: "filter-toggle-btn",
              on: { click: _vm.toggleFilterPanel },
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v(
                  _vm._s(
                    _vm.showFilterPanel ? "filter_list_off" : "filter_list"
                  )
                ),
              ]),
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.showFilterPanel
                      ? _vm.$t("chat.kanbanContactList.filterHide")
                      : _vm.$t("chat.kanbanContactList.filterAdd")
                  ) +
                  "\n            "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "toolbar-center" }, [
        _c(
          "div",
          { staticClass: "group-selector-container" },
          [
            _c("span", { staticClass: "selector-label" }, [
              _vm._v(_vm._s(_vm.$t("chat.tableContactList.grouping")) + ":"),
            ]),
            _vm._v(" "),
            _c("KanbanGroupSelector", {
              on: { change: _vm.handleGroupFieldChange },
              model: {
                value: _vm.selectedGroupField,
                callback: function ($$v) {
                  _vm.selectedGroupField = $$v
                },
                expression: "selectedGroupField",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.selectedGroupField === "lastBroadcastStatus"
          ? _c("div", { staticClass: "broadcast-selector-container" }, [
              _c("span", { staticClass: "selector-label" }, [
                _vm._v(
                  _vm._s(_vm.$t("chat.kanbanContactList.broadcast")) + ":"
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "broadcast-selector-wrapper" },
                [
                  _c(
                    "a-popover",
                    {
                      attrs: {
                        trigger: "click",
                        placement: "bottomLeft",
                        "overlay-class-name": "broadcast-popover",
                      },
                      model: {
                        value: _vm.broadcastPopoverVisible,
                        callback: function ($$v) {
                          _vm.broadcastPopoverVisible = $$v
                        },
                        expression: "broadcastPopoverVisible",
                      },
                    },
                    [
                      _c("div", { staticClass: "broadcast-input-wrapper" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.broadcastSearchText,
                              expression: "broadcastSearchText",
                            },
                          ],
                          staticClass: "broadcast-input",
                          attrs: {
                            type: "text",
                            placeholder: _vm.selectedBroadcast
                              ? _vm.selectedBroadcast.title
                              : _vm.$t(
                                  "chat.kanbanContactList.broadcastSelectPlaceholder"
                                ),
                          },
                          domProps: { value: _vm.broadcastSearchText },
                          on: {
                            focus: _vm.handleBroadcastInputFocus,
                            input: [
                              function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.broadcastSearchText = $event.target.value
                              },
                              _vm.handleBroadcastSearchInput,
                            ],
                          },
                        }),
                        _vm._v(" "),
                        _vm.selectedBroadcast
                          ? _c(
                              "span",
                              {
                                staticClass: "material-icons clear-icon",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.clearBroadcastSelection.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            close\n                        "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "material-icons dropdown-icon" },
                          [_vm._v("arrow_drop_down")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("template", { slot: "content" }, [
                        _c(
                          "div",
                          { staticClass: "broadcast-popover-content" },
                          [
                            _vm.broadcastSearching
                              ? _c(
                                  "div",
                                  { staticClass: "broadcast-loading" },
                                  [
                                    _c("a-spin", { attrs: { size: "small" } }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "chat.kanbanContactList.loading"
                                          )
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm.filteredBroadcastList.length === 0
                              ? _c("div", { staticClass: "broadcast-empty" }, [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v("info")]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "chat.kanbanContactList.broadcastNotFound"
                                        )
                                      )
                                    ),
                                  ]),
                                ])
                              : _c("div", { staticClass: "broadcast-table" }, [
                                  _c(
                                    "div",
                                    { staticClass: "broadcast-table-header" },
                                    [
                                      _c("div", { staticClass: "col-title" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "chat.kanbanContactList.broadcastTitle"
                                            )
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-date" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "chat.kanbanContactList.broadcastDate"
                                            )
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-status" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "chat.kanbanContactList.broadcastStatus"
                                            )
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-progress" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "chat.kanbanContactList.broadcastProgress"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "broadcast-table-body" },
                                    _vm._l(
                                      _vm.filteredBroadcastList,
                                      function (broadcast) {
                                        return _c(
                                          "div",
                                          {
                                            key: broadcast._id,
                                            staticClass: "broadcast-row",
                                            class: {
                                              selected:
                                                _vm.selectedBroadcast &&
                                                _vm.selectedBroadcast._id ===
                                                  broadcast._id,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.selectBroadcast(
                                                  broadcast
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-title" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "broadcast-title",
                                                    attrs: {
                                                      title: broadcast.title,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                " +
                                                        _vm._s(
                                                          broadcast.title
                                                        ) +
                                                        "\n                                            "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "col-date" },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.formatBroadcastDate(
                                                        broadcast.createdAt
                                                      )
                                                    ) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "col-status" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "status-badge",
                                                    class:
                                                      "status-" +
                                                      broadcast.status,
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                " +
                                                        _vm._s(
                                                          _vm.getStatusLabel(
                                                            broadcast.status
                                                          )
                                                        ) +
                                                        "\n                                            "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "col-progress" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "progress-info",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "progress-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getBroadcastProgress(
                                                              broadcast
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "progress-bar-container",
                                                      },
                                                      [
                                                        _c("div", {
                                                          staticClass:
                                                            "progress-bar-fill",
                                                          style: {
                                                            width:
                                                              _vm.getBroadcastProgressPercent(
                                                                broadcast
                                                              ) + "%",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]),
                          ]
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "toolbar-right" },
        [
          _c(
            "SupsisButton",
            {
              staticClass: "refresh-btn",
              attrs: { disabled: _vm.refreshDisabled },
              on: { click: _vm.handleRefresh },
            },
            [
              _c(
                "i",
                {
                  staticClass: "material-icons",
                  class: { rotating: _vm.isRefreshing },
                },
                [_vm._v("refresh")]
              ),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("chat.kanbanContactList.refresh")) +
                  "\n            "
              ),
            ]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm.showFilterPanel
      ? _c(
          "div",
          { staticClass: "kanban-filter-panel" },
          [
            _c("FiltersSection", {
              attrs: {
                filters: _vm.filters,
                state: _vm.state,
                "sort-disabled": true,
              },
              on: { "filters-changed": _vm.onFiltersChanged },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { ref: "kanbanWrapper", staticClass: "kanban-board-wrapper" }, [
      _c(
        "div",
        { staticClass: "kanban-board", style: { minWidth: _vm.boardMinWidth } },
        _vm._l(_vm.groupValues, function (group, index) {
          return _c("KanbanColumn", {
            key: group.value,
            attrs: {
              "group-value": group.value,
              "group-label": group.label,
              color: _vm.getColumnColor(group.value, index),
              contacts: _vm.columnContacts[group.value] || [],
              "is-collapsed": _vm.collapsedColumns.has(group.value),
              "is-loading": _vm.columnLoading[group.value],
              "has-more": _vm.columnHasMore[group.value],
              "total-count": group.count,
              "selected-contact-id": _vm.selectedContactId,
              "filter-change-key": _vm.filterChangeKey,
              "current-time": _vm.currentTime,
            },
            on: {
              "toggle-column": _vm.toggleColumn,
              "initial-load": _vm.handleInitialLoad,
              "load-more": function ($event) {
                return _vm.handleLoadMore(group.value)
              },
              "contact-click": _vm.handleContactClick,
            },
          })
        }),
        1
      ),
    ]),
    _vm._v(" "),
    _vm.initialLoading
      ? _c("div", { staticClass: "loading-overlay" }, [
          _c("div", { staticClass: "spinner-large" }),
          _vm._v(" "),
          _c("div", { staticClass: "loading-text" }, [
            _vm._v(_vm._s(_vm.$t("chat.kanbanContactList.kanbanLoading"))),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }